import { render, staticRenderFns } from "./OVDetailClienteData.vue?vue&type=template&id=064b9f24&scoped=true&lang=pug"
import script from "./OVDetailClienteData.vue?vue&type=script&lang=js"
export * from "./OVDetailClienteData.vue?vue&type=script&lang=js"
import style0 from "./OVDetailClienteData.vue?vue&type=style&index=0&id=064b9f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b9f24",
  null
  
)

export default component.exports